// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"69abc411","455":"5d34373d","977":"97f3045c"}[chunkId] + ".chunk.js";
};